module.exports = __webpack_public_path__ + "img/798.a1c28b6d.jpg";